module.exports = __webpack_public_path__ + "assets/0e832fd00bf660a6b9d984656f56495f.png";